/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimProperty
 */
export interface ClaimProperty {
    /**
     * 
     * @type {number}
     * @memberof ClaimProperty
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimProperty
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimProperty
     */
    claimId: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimProperty
     */
    propertyId: number;
    /**
     * 
     * @type {string}
     * @memberof ClaimProperty
     */
    addressType: ClaimPropertyAddressTypeEnum;
    /**
     * Enriched insured name from joined claim table
     * @type {string}
     * @memberof ClaimProperty
     */
    insuredName?: string;
    /**
     * Enriched claim number from joined claim table
     * @type {string}
     * @memberof ClaimProperty
     */
    claimNumber?: string;
    /**
     * Enriched street address from joined property table
     * @type {string}
     * @memberof ClaimProperty
     */
    streetAddress?: string;
    /**
     * Enriched unit from joined property table
     * @type {string}
     * @memberof ClaimProperty
     */
    unit?: string | null;
    /**
     * Enriched city from joined property table
     * @type {string}
     * @memberof ClaimProperty
     */
    city?: string;
    /**
     * Enriched state from joined property table
     * @type {string}
     * @memberof ClaimProperty
     */
    state?: string;
    /**
     * Enriched ZIP code from joined property table
     * @type {string}
     * @memberof ClaimProperty
     */
    zipCode?: string;
    /**
     * 
     * @type {Date}
     * @memberof ClaimProperty
     */
    createdAt: Date;
}


/**
 * @export
 */
export const ClaimPropertyAddressTypeEnum = {
    Loss: 'loss',
    Billing: 'billing',
    Other: 'other'
} as const;
export type ClaimPropertyAddressTypeEnum = typeof ClaimPropertyAddressTypeEnum[keyof typeof ClaimPropertyAddressTypeEnum];


/**
 * Check if a given object implements the ClaimProperty interface.
 */
export function instanceOfClaimProperty(value: object): value is ClaimProperty {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('propertyId' in value) || value['propertyId'] === undefined) return false;
    if (!('addressType' in value) || value['addressType'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function ClaimPropertyFromJSON(json: any): ClaimProperty {
    return ClaimPropertyFromJSONTyped(json, false);
}

export function ClaimPropertyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimProperty {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'claimId': json['claimId'],
        'propertyId': json['propertyId'],
        'addressType': json['addressType'],
        'insuredName': json['insuredName'] == null ? undefined : json['insuredName'],
        'claimNumber': json['claimNumber'] == null ? undefined : json['claimNumber'],
        'streetAddress': json['streetAddress'] == null ? undefined : json['streetAddress'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function ClaimPropertyToJSON(json: any): ClaimProperty {
    return ClaimPropertyToJSONTyped(json, false);
}

export function ClaimPropertyToJSONTyped(value?: ClaimProperty | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'claimId': value['claimId'],
        'propertyId': value['propertyId'],
        'addressType': value['addressType'],
        'insuredName': value['insuredName'],
        'claimNumber': value['claimNumber'],
        'streetAddress': value['streetAddress'],
        'unit': value['unit'],
        'city': value['city'],
        'state': value['state'],
        'zipCode': value['zipCode'],
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

